import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Clock, Award, ChevronRight, PlayCircle } from "lucide-react";

export default function CourseDetail() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/courses/${id}`).then((r) => setCourse(r.data)).catch(() => nav("/"));
  }, [id, nav]);

  if (!course) return <div className="p-10 text-marino">Cargando...</div>;

  return (
    <div className="pb-24 md:pb-8">
      <section className="bg-marino text-white">
        <div className="max-w-7xl mx-auto px-6 py-12 grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <span className="inline-block bg-naranja/20 text-naranja text-xs uppercase tracking-widest px-3 py-1 rounded-full font-semibold mb-3">
              Curso profesional
            </span>
            <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-tight">{course.title}</h1>
            <p className="mt-4 text-white/80 text-base sm:text-lg leading-relaxed max-w-2xl">{course.description}</p>
            <div className="mt-6 flex flex-wrap gap-4 text-sm">
              <span className="inline-flex items-center gap-1"><Clock className="w-4 h-4 text-naranja" /> {course.duration_hours} horas</span>
              <span className="inline-flex items-center gap-1"><Award className="w-4 h-4 text-naranja" /> Aprobación ≥ {course.passing_score}%</span>
              {course.teacher_name && <span>Instructor {course.teacher_name}</span>}
            </div>
          </div>
          <div className="bg-white text-marino rounded-2xl p-6 shadow-lg border border-white/20 h-fit sticky top-24">
            <div className="text-marino/70 text-sm">Inversión</div>
            <div className="font-heading font-black text-4xl mt-1">${course.price}</div>
            <Link
              to={`/checkout/${course.id}`}
              data-testid="course-detail-buy"
              className="mt-5 block text-center bg-naranja text-white px-6 py-3 rounded-lg font-medium hover:bg-naranjaHover transition-colors"
            >
              Empezar curso
            </Link>
            <Link
              to="/redeem"
              data-testid="course-detail-redeem"
              className="mt-2 block text-center bg-gris text-marino px-6 py-3 rounded-lg font-medium hover:bg-grisHover transition-colors"
            >
              Activar con código
            </Link>
            <ul className="mt-5 space-y-2 text-sm text-marino/80">
              <li>✓ Acceso vitalicio al contenido</li>
              <li>✓ {course.lessons?.length || 0} lecciones prácticas</li>
              <li>✓ Examen diagnóstico + final</li>
              <li>✓ Certificado en PDF al aprobar</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-12">
        <h2 className="font-heading font-bold text-marino text-2xl sm:text-3xl tracking-tight mb-6">Temario</h2>
        <div className="bg-white border border-gris/30 rounded-xl overflow-hidden shadow-sm">
          {(course.lessons || []).map((l, i) => (
            <div key={l.id} className="flex items-center gap-3 p-4 border-b border-gris/20 last:border-0">
              <div className="w-8 h-8 rounded-full bg-marino/10 text-marino flex items-center justify-center text-sm font-bold">{i + 1}</div>
              <PlayCircle className="w-5 h-5 text-naranja" strokeWidth={1.75} />
              <div className="flex-1">
                <div className="font-medium text-marino">{l.title}</div>
              </div>
              <ChevronRight className="w-4 h-4 text-gris" />
            </div>
          ))}
        </div>
      </section>

      {/* Sticky mobile CTA */}
      <div className="fixed md:hidden bottom-0 left-0 right-0 bg-white border-t border-gris/30 p-3 z-30">
        <Link
          to={`/checkout/${course.id}`}
          className="block bg-naranja text-white text-center px-6 py-3 rounded-lg font-semibold hover:bg-naranjaHover"
        >
          Empezar curso · ${course.price}
        </Link>
      </div>
    </div>
  );
}
